import React, { Component } from 'react';
import firebase from '../../config/Firebase'
class Home extends Component {

    componentDidMount() {
        var user = firebase.auth().currentUser;
        if (user !== null) {
            // console.log(user);
            // console.log(user.uid);
            firebase.database().ref('/users/' + user.uid).once('value').then(snapshot => {
                var name = (snapshot.val() && snapshot.val().name) || 'Anonymous';
                return name;
            })
        }
    }
    render() {
        return (
            <div>
                Home page
            </div>
        );
    }
}

export default Home;
